import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  getAllMonthlyExpenseRedux,
  getAllMonthlyCashInRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./monthlyexpense.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllMonthlyExpenseRedux();
    this.props.getAllMonthlyCashInRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };
  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };
  render() {
    const { open } = this.state;

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Cash history" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid mh-page kd-cash kd-st--sky">
          <Tabs>
            <TabList
              className="nav nav-tabs tab-coupon mh-tablist"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Tab
                className="nav-link mh-tab"
                onClick={(e) => this.clickActive(e)}
              >
                Cash Out
              </Tab>

              <Tab
                className="nav-link mh-tab"
                onClick={(e) => this.clickActive(e)}
              >
                Cash In
              </Tab>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card mh-card">
                    <div className="card-header mh-card-header">
                      <h5 className="mh-card-title">
                        <i className="icofont-bill mh-card-icon"></i>
                        Cash Out
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.props.allMonths}
                          pageSize={50}
                          pagination={true}
                          className="-striped -highlight mh-table"
                          type="expense"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card mh-card">
                    <div className="card-header mh-card-header">
                      <h5 className="mh-card-title">
                        <i className="icofont-bill mh-card-icon mh-card-icon--success"></i>
                        Cash In
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.props.allMonthsCashIns}
                          pageSize={50}
                          pagination={true}
                          className="-striped -highlight mh-table"
                          type="cashIn"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.expenses.monthlyExpenses,
    allMonthsCashIns: state.cashIns.monthlyCashIns,
  };
};

export default connect(mapStateToProps, {
  getAllMonthlyExpenseRedux,
  getAllMonthlyCashInRedux,
})(MonthlyExpense);
